<template>
	<div>
		<div v-show="mapaSelecionado === 1">
			<div class="row" style="margin:0px" :style="{ 'margin-top': _isMobile ? '-50px' : '0px' }">		
				<div class="col-md-8 col-lg-12" style="padding:0px;">				
					<div id="mapa" ref="map"
						:style="{'height': this.maxHeight + 'px', 'width': this.maxWidth + 'px' }">    
					</div>  
				</div>                  
			</div>
		</div>
		<div v-if="mapaSelecionado === 2">
			<div class="row" style="margin:0px;" :style="{ 'margin-top': _isMobile ? '-50px' : '0px' }">			
				<div class="col-md-8 col-lg-12" style="padding:0px;" v-if="posicoes.length > 0 && (markerCircle.length > 0 || carregaCirculo == true)">
					<l-map :style="{'height': this.maxHeight + 'px', 'width': this.maxWidth + 'px' }" :zoom=3 :center="[-19.936126, -43.937622]" >
						<l-control-layers position="topleft"></l-control-layers>
						<div style="position: absolute; top: 10px; left: 10px; z-index: 1000; padding-top: 125px;">
							<button @click="exibirMapa(1)" class="btn btn-sm btn-primary">GOOGLE MAPS</button>
							<div style="padding-top: 10px;">
								<label style="color: green;">
									<input type="checkbox" v-model="exibirVeiculos" />
									<span style="font-weight: bold;">Exibir veículos</span>
								</label>
								<br>
								<label style="color: green;">
									<input type="checkbox" v-model="exibirTrilhas" />
									<span style="font-weight: bold;">Exibir trilhas</span>
								</label>
							</div>			
						</div>
						<l-marker v-for="(coord, markerIndex) in markerCoordinates" :key="'marker_' + markerIndex + '_' + refreshKey" :lat-lng="coord.cordenadas" :icon="customIcon[markerIndex]">
							<l-tooltip :content="coord.informacoes" :offset="[0, -25]"></l-tooltip>
						</l-marker>
						<l-circle v-for="(coord, circleIndex) in markerCircle" :key="'circle_' + circleIndex" :lat-lng="coord" :radius="radius" :fill-color="colorRadius" :color="colorRadius" :stroke="true" ></l-circle>
						<l-tile-layer
							v-for="tileProvider in tileProviders"
							:key="tileProvider.name"
							:name="tileProvider.name"
							:visible="tileProvider.visible"
							:url="tileProvider.url"
							:attribution="tileProvider.attribution"
							layer-type="base"/>		
							<l-wms-tile-layer
								:key="wmsLayer.name"
								:base-url="wmsLayer.url"
								:layers="wmsLayer.layers"
								:visible="wmsLayer.visible"
								:name="wmsLayer.name"
								:attribution="wmsLayer.attribution"
								:transparent="true"
								format="image/png"
								layer-type="base">
							</l-wms-tile-layer>			
							<l-polyline v-if="exibirTrilhas" :lat-lngs="polylineOSM.latlngs" :color="polylineOSM.color"></l-polyline>
							
					</l-map>
				</div>
			</div>
		</div>
	<div class="right">
		<div class="theme-toggler">
			<span class="material-icons-sharp active" style="color:var(--color-white)">light_mode</span>
			<span class="material-icons-sharp" style="color:var(--color-white)">dark_mode</span>
		</div>
	</div>
	<flDashboard :aeronaveEmMovimento="aeronaveEmMovimento" :aeronaveParada="aeronaveParada"
		:posicaoTravada="posicaoTravada" :trechoTravado="trechoTravado" :servidoresTravados="servidoresTravados"
		:servicosTravados="servicosTravados" />

		<flHistoricoOperacional :events="events" />

		<flDadosVooMobile @fechar="clickCentralizar" :posicaoAtual="posicaoAtual" />

		<div v-if="exibeMenu" class="animated slideInUp monitoramento-mobile">

			<flListaAeronaves @equipamento="(equipamento) => { clickAeroMapa(equipamento.imei) }"
				@limpa-cliente="() => { cliente = { id: null }; clickCentralizar() }"
				@seta-cliente="(item) => { cliente = item }" :cliente="cliente" :clientes="clientes" />

			<div class="iphone-x-bottom"></div>

		</div>

		<div class="d-block d-sm-none btn-aeronave-fechar">
			<button @click="exibeMenu = !exibeMenu" class="btn btn-primary btn-sm btn-block">
				<span v-if="!exibeMenu">
					<fa-icon icon="satellite-dish" style="margin-top:-3px" /> AERONAVES
				</span>
				<span v-if="exibeMenu">
					<fa-icon icon="times" style="margin-top:-3px" /> FECHAR
				</span>
			</button>
			<div class="iphone-x-bottom"></div>
		</div>

		<button type="button" :class="{ 'btn-centralizar': !_isMobile, 'btn-centralizar-mobile': _isMobile }"
			v-show="centralizar" @click="clickCentralizar()" class="btn btn-sm btn-light">
			EXIBIR TODAS
		</button>
		 
	</div>
</template>

<style>
#cardsDiv {
	position: absolute;
	z-index: 9;
	cursor: move;
	background-color: #f1f1f1;
	border: 1px solid #f1f1f1;
	text-align: center;
	opacity: 0.8;
	box-shadow: 0 0 40px -10px rgba(0, 0, 0, .8);
}

.list-group-item {
	background-color: rgb(30, 30, 30);
	box-shadow: 0 0 40px -10px rgba(255, 255, 255, .8);
}

.listLetter {
	color: #f1f1f1;
}
</style>

<script>

import $ from "jquery"
import _ from 'lodash'
import flListaAeronaves from './lista-aeronaves'
import flDadosVoo from './card-dados-voo'
import flDashboard from './dashboard'
import flHistoricoOperacional from './historico-operacional.vue'
import flDadosVooMobile from './card-dados-voo-mobile'
import $mapa from '../../library/mapa'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from '../../routers/axios'

export default {

	components: {
		flListaAeronaves,
		flDadosVoo,
		flDadosVooMobile,
		flDashboard,
		flHistoricoOperacional
	},

	mixins: [$mapa],

	data() {
		return {
			events: [],
			height: 0,
			dark: false,
			maxHeight: window.innerHeight,
			maxWidth: window.innerWidth,
			cliente: { id: null },
			exibeMenu: false,
			posicoes: [],
			equipamentos: [],
			clientes: [],
			clientesAtivo: [],
			conorPosicao: {},
			posicaoTravada: 0,
			trechoTravado: 0,
			servidoresTravados: 0,
			servicosTravados: 0,
			centralizar: false,
			controleClicou: false,
			aeronaveEmMovimento: 0,
			aeronaveParada: 0,
			aeroSelecionada: "", 
			label: "",
			timeOut: '',
			stopBusca: false,
			posicaoAtual: {},
			configMapa: {
				lat: 0,
				long: 0,
				zoom: 0
			},
			url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
			attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			markerCoordinates: [],
			customIcon: [],
			markerCircle: [],
			radius: 1000000,
			colorRadius: 'blue',
			mapaSelecionado: 1,
			carregaCirculo: false,
			refreshKey: 0,
			exibirVeiculos: false,
			controlPosition: 'topleft',
			selectedLayer: null,
			showLayerSettings: false,
			polylineOSM: {
        latlngs: [],
        color: 'green'
      },
			imeis: [],
			wmsLayer: {
        url: 'http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi',
        name: 'Weather Data',
        visible: true,
        format: 'image/png',
        layers: 'nexrad-n0r-900913',
        transparent: true,
        attribution: 'Weather data &copy; 2012 <a href="https://mesonet.agron.iastate.edu/docs/nexrad_mosaic/">IEM Nexrad</a>',
      },
			exibirTrilhas: false,
			tileProviders: [
				{
				name: 'OpenStreetMap',
				visible: true,
				attribution:
					'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				},
				{
				name: 'Topo Map',
				visible: false,
				url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
				attribution:
					'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
				},
				{
				name: 'Esri.WorldImagery',
				visible: false,
				url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
				attribution:
					'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
				},
				{
				name: 'OPNVKarte',
				visible: false,
				url: 'https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png',
				attribution:
					'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				},
				{
				name: 'Esri.NatGeoWorldMap',
				visible: false,
				url: 'https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
				attribution:
					'Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC',
				},
				{
				name: 'USGS.USImageryTopo',
				visible: false,
				url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}',
				attribution:
				'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>',
				},						
			],
		};
	},

	computed: {
		...mapState({
			webSocket: state => state.sessao.webSocket,
			sessao: state => state.sessao.user,
		}),
	},

	watch: {
		webSocket(val) {
			if (val) {
				this.getPositions()
				this.receivePositions()
			}
		}
	},

	mounted() {

		window.onresize = function (event) {
			this.maxHeight = window.innerHeight
			this.maxWidth = window.innerWidth
			document.getElementById("mapa").style["height"] = this.maxHeight + "px";
			document.getElementById("mapa").style["width"] = this.maxWidth + "px";
		}

		this.height = this._height - 20

		// this.setMap(this.map)
		this.markerInicio = new google.maps.Marker()

		this.iniciaMapa(this.$refs.map, -19.936126, -43.937622, 3)

		this.adicionaBotoes()

		this.geraEventosMapa()

		setInterval(this.refreshMarkers, 5000);
		//	this.draggableElements()
		axios.get(this._getUrl("api/equipamento")).then(response => {

			this.equipamentos = response.data.map(item => {
				item._selecionado = false;
				return item;
			});

			axios.get(this._getUrl("api/cliente/GetListaAtivos")).then(response => {
				this.clientesAtivo = response.data

				this.clientesAtivo = response.data.map(item => {
					item.equipamentos = this.getEquipamentoByIdCliente(item.id);
					return item;
				});

				this.clientes = response.data.map(item => {
					item._exibir = false;
					item.equipamentos = this.getEquipamentoByIdCliente(item.id);
					return item;
				});

				this.$nextTick(() => {
					if (this.webSocket) {
						this.getPositions()
						this.receivePositions()
					}
				})
			});
		});
		const themeToggler = document.querySelector(".theme-toggler");

		themeToggler.addEventListener('click', () => {
			document.body.classList.toggle('dark-theme-variables');

			themeToggler.querySelector('span:nth-child(1)').classList.toggle('active');
			themeToggler.querySelector('span:nth-child(2)').classList.toggle('active');

			if (!this.dark) {
				this.map.set('styles', [
					{
						featureType: "all",
						elementType: "all",
						stylers: [
							{ invert_lightness: true }
						]
					}
				]);

				this.dark = true
			}

			else
			{
				this.map.set('styles', [
					{
						featureType: "all",
						elementType: "all",
						stylers: [
							{ invert_lightness: false }
						]
					}
				]);

				this.dark = false
			}
		});
	},

	methods: {
		getPositions() {
			$webSocket.invoke("GetPositions", this.sessao.token).then(posicoes => {
				// this.$notify.loadOut()
				if (!_.isNil(posicoes)) {
					this.processaPosicoes(posicoes, true);
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			$webSocket.invoke("GetEvents", this.sessao.token).then(eventos => {
				if (!_.isNil(eventos)) {
					this.events = eventos
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			$webSocket.invoke("PosicoesTravadas", this.sessao.token).then(posicoesEnvio => {
				// this.$notify.loadOut()

				if (!_.isNil(posicoesEnvio)) {
					this.posicaoTravada = posicoesEnvio.length
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			$webSocket.invoke("TrechosTravados", this.sessao.token).then(trechosEnvio => {
				// this.$notify.loadOut()
				if (!_.isNil(trechosEnvio)) {
					this.trechoTravado = trechosEnvio.length
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			$webSocket.invoke("ServidoresTravados", this.sessao.token).then(servidoresEnvio => {

				if (!_.isNil(servidoresEnvio)) {
					this.servidoresTravados = servidoresEnvio.length
				}
				else {
					this.servidoresTravados = 0
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			$webSocket.invoke("ServicosTravados", this.sessao.token).then(servicos => {

				if (!_.isNil(servicos)) {
					this.servicosTravados = servicos.length
				}
				else {
					this.servicosTravados = 0
				}

				this.$forceUpdate()
			}).catch(err => {
				console.error("erro websoket", err.toString());
			});

			this.iniciaBusca()
		},

		iniciaBusca() {
			if (this.stopBusca == false) {

				setTimeout(() => {
					this.getPositions()
				}, 10000)
			}
		},

		receivePositions() {
			$webSocket.on("ReceivePositions", () => {
				console.log("recebeu posicao")
				this.getPositions();
			});
		},

		getEquipamentoByIdCliente(idCliente) {
			let equipamentos = [];

			for (var i = 0; i < this.equipamentos.length; i++) {
				if (
					this.equipamentos[i].idCliente == idCliente &&
					this.equipamentos[i].ativo
				) {
					equipamentos.push(this.equipamentos[i]);
				}
			}

			return equipamentos;
		},

		geraEventosMapa() {

			this.map.addListener("zoom_changed", () => {
				if (this.controleClicou == true) {
					this.controleClicou = false;
				} else {
					this.centralizar = true;
				}
			});

			this.map.addListener("drag", () => {
				this.centralizar = true;
			});
		},

		limpaSelecionado() {
			this.clientes = this.clientes.map(item => {
				item.equipamentos = item.equipamentos.map(equip => {
					equip._selecionado = false;
					return equip;
				});

				return item;
			});
		},

		exibirMapa(mapaCodigo) {
			this.mapaSelecionado = mapaCodigo;
		}, 

		refreshMarkers() {
			this.refreshKey += 1;
		},

		adicionarCustomIcon(emMovimento, item) {

			item._label = this.geraInfoView(item)
			var imgUrl = this.getIcon(item._equipamento.tipo, item.emMovimento, item.direcao, false, item._equipamento.idCliente)			
			this.markerCoordinates.push({cordenadas: [parseFloat(item.lat), parseFloat(item.lng)], informacoes: item._label});	
			var size = 0;

			if (emMovimento== 'Y'){
				size = 50

				if (item._equipamento.idCliente !== 57){
					var dataAgora = new Date().toLocaleString()
					var dataAgoraSplit = dataAgora.split(' ');
					var itemDataAgoraSplit = item.data.split(' ');

					dataAgoraSplit = dataAgoraSplit[1].split(':');
					itemDataAgoraSplit = itemDataAgoraSplit[1].split(':')			

					if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 10)) {
						this.markerCircle.push([item.lat, item.lng]);
						this.radius = size * 20000 * 1 / 3;
						this.colorRadius = '#8b0000';
					}
					else if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 5)) {
						this.markerCircle.push([item.lat, item.lng]);
						this.radius = size * 20000 * 1 / 3;
						this.colorRadius = '#ff8c00';
					}			
					else if (parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) < 5)	{
						this.markerCircle.push([item.lat, item.lng]);
						this.radius = 0;
					}
				}
					
			}
			else{
				size = 20
				this.carregaCirculo = true;
			}
						
			var options = {
				iconUrl: imgUrl,
				iconSize: [size, size],
				popupAnchor: [-3, -76]
			}

			var customIconL = L.icon(options);
			this.customIcon.push(customIconL);
			
		},

		processaPosicoes(posicoes, processaData) {
			var atualizar = false;
			if (this.markers.length > 0) {
				atualizar = true;
			}

			this.controleClicou = true;

			if (processaData) {
				this.posicoes = posicoes.map(item => {
					item.data = new moment.utc(item.dataUTC)
						.local()
						.format("DD/MM/YYYY HH:mm");
					item.dataUTC = new moment.utc(item.dataUTC).format(
						"DD/MM/YYYY HH:mm"
					);

					item._equipamento = _.find(this.equipamentos, o => {
						return o.imei == item.imei;
					});
					return item;
				});
			}

			var bounds = new google.maps.LatLngBounds();
			this.aeronaveParada = 0
			this.aeronaveEmMovimento = 0
			this.markerCoordinates = [];
			this.markerCircle = [];
			this.customIcon = [];
			this.imeis = [];

			for (var i in posicoes) {
				if (posicoes[i].lat != null) {
					if (posicoes[i]._equipamento.idCliente !== 57 && this.mapaSelecionado == 1){
						if (posicoes[i].emMovimento == 'N')
							this.aeronaveParada++

						if (posicoes[i].emMovimento == 'Y')
							this.aeronaveEmMovimento++

						this.adicionarCustomIcon(posicoes[i].emMovimento, posicoes[i]);
					}
					else if (this.mapaSelecionado == 2){
						if (this.exibirVeiculos){
							if (posicoes[i].emMovimento == 'N')
								this.aeronaveParada++

							if (posicoes[i].emMovimento == 'Y')
								this.aeronaveEmMovimento++

							this.adicionarCustomIcon(posicoes[i].emMovimento, posicoes[i]);					
						}
						else if (!this.exibirVeiculos && posicoes[i]._equipamento.idCliente !== 57){
							if (posicoes[i].emMovimento == 'N' && posicoes[i]._equipamento.idCliente !== 57)
								this.aeronaveParada++

							if (posicoes[i].emMovimento == 'Y' && posicoes[i]._equipamento.idCliente !== 57)
								this.aeronaveEmMovimento++	

							this.adicionarCustomIcon(posicoes[i].emMovimento, posicoes[i]);
						}
					}

					if ( posicoes[i]._equipamento.idCliente !== 57){
						this.imeis.push(posicoes[i].imei);					
					} 
					
					if (atualizar) {
						if(this.mapaSelecionado == 1){
							this.atualizaMarker(posicoes[i], i)
						}					
					} else if (this.mapaSelecionado == 1){
						this.insereMarker(posicoes[i], i)

						if (this.markers[i]) this.geraEventoDoMapa(this.markers[i], i);
					}

					bounds.extend({ lat: Number(posicoes[i].lat), lng: Number(posicoes[i].lng) })
								
					if(this.exibirTrilhas && posicoes[i].emMovimento == 'Y'){
						$webSocket.invoke("GetTilha", posicoes[i].imei, this.sessao.token).then(trilhas => {				
							if (trilhas.length > 0) {
									var coordenadasPorImei = {};

									for (var i = 0; i < trilhas.length; i++) {
											var trilha = trilhas[i];
											if (this.imeis.includes(trilha.imei)) {
													var imei = trilha.imei;
													if (!coordenadasPorImei[imei]) {
															coordenadasPorImei[imei] = [];
													}
													coordenadasPorImei[imei].push([Number(trilha.lat), Number(trilha.lng)]);
											}
									}
									
									var latlngs = Object.values(coordenadasPorImei);
									this.polylineOSM.latlngs.push(latlngs);	
									console.log('latlngs:', latlngs);
									console.log('this.polylineOSM.latlngs', this.polylineOSM.latlngs)
							}


						}).catch(err => {
							console.error("erro websoket", err.toString());
						});			
					}								
					
					this.refreshMarkers();
				}
			}

			if (this.aeroSelecionada != "") {
				//	this.posicaoAtual = _.find(this.posicoes, o => { return o._equipamento.imei == this.aeroSelecionada.imei; });
				$webSocket.invoke("GetTilha", this.aeroSelecionada.imei, this.sessao.token).then(trilhas => {
					this.removePolylines()
					if (trilhas.length > 0) {
						this.geraTrilha(trilhas)
					}
				}).catch(err => {
					console.error("erro websoket", err.toString());
				});

			} else {
				// centraliza o mapa
				if (this.centralizar == false) {
					this.fitBounds(bounds);
				}
			}
		},

		geraEventoDoMapa(marker, p) {

			// evento de click
			google.maps.event.addListener(marker, "click", ((marker, p) => {
				return () => {
					this.clickAeroMapa(marker.id);
				};
			})(marker, p)
			)
		},

		clickCentralizar() {
			this.centralizar = false;
			this.controleClicou = true; // controle para não exibir o botão centralizar ao mudar o zoom
			this.removePolylines()
			this.markerInicio.setMap(null);

			this.cliente = { id: null }
			this.limpaSelecionado();
			this.aeroSelecionada = "";
			this.posicaoAtual = {};

			this.getPositions();
		},

		// gera o info view da aeronave
		geraInfoView(item) {
			var info = new Object();
			var data = "";

			// cabecalho
			data =
				"<div style='overflow-x: hidden;'><table style='width:100%'>";
			data += "<tr style='border-bottom:1px solid #F0F0F0'>";
			data +=
				"<td style='padding-bottom: 10px;color: #1976D2; font-size:16px; vertical-align:top'>";
			data += "<strong>INFORMAÇÃO</strong>";
			data += "</td>";
			data += "</tr>";

			// informacoes de posicoes
			data += "<tr>";
			data +=
				"<td style='vertical-align:top; padding-top: 10px;'>";
			data += "<table style='width:100%'>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>PREFIXO</strong>: </td><td class='pd-table-gmap-aero'>" +
				item._equipamento.prefixo +
				"</td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>CLIENTE</strong>: </td><td class='pd-table-gmap-aero'>" +
				item._equipamento.nomeCliente +
				"</td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>FABRICANTE</strong>: </td><td class='pd-table-gmap-aero'>" +
				item._equipamento.fabricante +
				"</td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>EQUIPAMENTO</strong>: </td><td class='pd-table-gmap-aero'>" +
				item._equipamento.modelo +
				"</td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>IMEI</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.imei +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>REGISTRO</strong>: </td><td class='pd-table-gmap-aero'>" +
				item._equipamento.registro +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero' colspan='2'><hr style='margin-top:10px;margin-bottom:10px' /></td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>LOCAL</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.data +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>UTC</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.dataUTC +
				"</td></tr>";

			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>VELOCIDADE</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.velocidade +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>ALTITIDADE</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.altitude +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>DIREÇÃO</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.direcao +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>LAT</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.lat +
				"</td></tr>";
			data +=
				"<tr><td class='pd-table-gmap-aero'><strong>LNG</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.lng +
				"</td></tr>";
			data += "</table>";
			data += "</td>";

			data += "</tr>";
			data += "</table></div>";

			return data;
		},
	}
};
</script>

<style lang="scss">
.right {
	margin-top: .6rem;
	right: 5px;
	border-radius: 5px;
	position: absolute;
}

.right .theme-toggler {
	background: var(--color-dark);
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 1.6rem;
	width: 4.2rem;
	cursor: pointer;
	border-radius: var(--border-radius-1);
}

.btn-aeronave-fechar {
	position: fixed;
	bottom: 0px;
	width: 100%;
	padding: 1em;
	z-index: 1;
	// padding-bottom: calc(env(safe-area-inset-bottom) + 1em);
}

.monitoramento-mobile {
	position: fixed;
	bottom: 0px;
	width: 100%;
	padding: 1em;
	background: #FFF;
	padding-bottom: 60px
}


.item-background {
	margin-top: 0.4em;
	border-bottom: 1px solid #F0F0F0;
}

.item-background:hover {
	color: #0052CC !important;
	background: rgba(9, 30, 66, 0.04);
	border-radius: 2px !important;
	/* border: 1px solid #0052CC !important; */
}

.subitem-background:hover {
	color: #0052CC !important;
	/* border: 1px solid #0052CC !important; */
	border-radius: 2px !important;
}

.item-open {
	color: #0052CC !important;
	background: rgba(9, 30, 66, 0.04);
	border: 1px solid #0052CC !important;
	border-radius: 2px !important;
}

.subitem-selected {
	color: #0052CC !important;
	background: rgba(9, 30, 66, 0.04);
	/* border: 1px solid #0052CC !important; */
	border-radius: 2px !important;
}

.btn-centralizar {
	z-index: 10;
	position: absolute;
	top: 10px;
	right: 13rem;
	font-size: 0.8rem;
}

.btn-centralizar-mobile {
	z-index: 20;
	position: absolute;
	top: calc(env(safe-area-inset-top) + 3.78rem);
	right: 0.8rem;
	border: 0px;
	padding: 10px 11px;
	font-size: 0.8rem;
	box-shadow: rgba(0, 0, 0, 0.298) 0px 1px 4px -1px;
}

.gm-style-iw-c {
	padding: 8px 2px 8px 20px !important;
}

.gm-ui-hover-effect {
	background: none;
	display: block;
	border: 0px;
	margin: 0px;
	padding: 0px;
	position: absolute;
	cursor: pointer;
	user-select: none;
	top: 0px !important;
	width: 30px;
	height: 30px;
	right: 20px !important;

	img {
		pointer-events: none;
		display: block;
		width: 26px !important;
		height: 26px !important;
		margin: 0px 8px !important;
		margin-top: 7px !important;
	}

	.custom-layer-control {
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 100;
	}

	.layer-settings {
		background-color: white;
		border: 1px solid #ccc;
		position: absolute;
		top: 30px;
		left: 0;
		padding: 10px;
		max-height: 150px;
		overflow-y: auto;
		z-index: 100;
		}

	.settings-button {
		position: absolute;
		top: 10px; /* Ajuste conforme necessário */
		left: 10px; /* Ajuste conforme necessário */
		z-index: 1000; /* Ajuste conforme necessário */
		}
}
</style>



// WEBPACK FOOTER //
// src/views/monitoramento/main.vue